import { render, staticRenderFns } from "./primaryLeftColumnBlock.vue?vue&type=template&id=3562a9a0&scoped=true&"
import script from "./primaryLeftColumnBlock.vue?vue&type=script&lang=js&"
export * from "./primaryLeftColumnBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3562a9a0",
  null
  
)

export default component.exports